<template>
   <div>
        <el-button type="primary" @click="connectDevice" v-if="!connected">连接设备</el-button>
        <el-button type="danger" @click="disconnectDevice" v-if="connected">断开连接</el-button>
      </div>
    <div class="file-reader">
      <el-upload
        action="#"
        accept=".bin"
        :auto-upload="false"
        :on-change="handleFileChange"
        :show-file-list="false"
      >
        <template #trigger>
          <el-button type="primary">选择本地文件</el-button>
        </template>
      </el-upload>
      
      <div v-if="fileInfo" class="file-info">
        <el-progress
          :text-inside="true"
          :stroke-width="16"
          :percentage="progress"
          status="success"
        />
        <p>文件名: {{ fileInfo.name }}</p>          
        <p>文件大小: {{ arrayBufferData?.byteLength }} bytes</p>
        <p>CRC32: {{ crc.toString(16) }}  {{ crc }} </p>
        <el-button type="danger" @click="sendEraseCmd" >擦除</el-button>
        <el-button type="danger" @click="sendData(false)" >下载</el-button>
        <el-button type="danger" @click="sendData(true)" >校验</el-button>
        <el-button type="danger" @click="checkCRC" >CRC</el-button>
        <el-button type="danger" @click="sendFinishCmd" >完成</el-button>
      </div>
          <div class="logs">
      <h3>日志</h3>
      <div v-for="(log, index) in logs" :key="index" class="log-item">
        [{{ log.timestamp }}] {{ log.message }}
      </div>
    </div>
    </div>
  </template>
  
  <script setup>
  import { ref,reactive } from 'vue'
  import { ElMessage } from 'element-plus'

  const logs = reactive([])
const connected = ref(false)
const device = ref(null)
const progress = ref(0)
const crc = ref(0)

let server = null
let service = null 
let characteristic = null
let sendArrayBuffer = null

let imgType = null
let offset =  null
let blockSize =  null
let chip =  null

const crc32 = (ab)=>{

let table = new Uint32Array([
    0x00000000, 0x77073096, 0xee0e612c, 0x990951ba, 0x076dc419, 0x706af48f,
    0xe963a535, 0x9e6495a3, 0x0edb8832, 0x79dcb8a4, 0xe0d5e91e, 0x97d2d988,
    0x09b64c2b, 0x7eb17cbd, 0xe7b82d07, 0x90bf1d91, 0x1db71064, 0x6ab020f2,
    0xf3b97148, 0x84be41de, 0x1adad47d, 0x6ddde4eb, 0xf4d4b551, 0x83d385c7,
    0x136c9856, 0x646ba8c0, 0xfd62f97a, 0x8a65c9ec, 0x14015c4f, 0x63066cd9,
    0xfa0f3d63, 0x8d080df5, 0x3b6e20c8, 0x4c69105e, 0xd56041e4, 0xa2677172,
    0x3c03e4d1, 0x4b04d447, 0xd20d85fd, 0xa50ab56b, 0x35b5a8fa, 0x42b2986c,
    0xdbbbc9d6, 0xacbcf940, 0x32d86ce3, 0x45df5c75, 0xdcd60dcf, 0xabd13d59,
    0x26d930ac, 0x51de003a, 0xc8d75180, 0xbfd06116, 0x21b4f4b5, 0x56b3c423,
    0xcfba9599, 0xb8bda50f, 0x2802b89e, 0x5f058808, 0xc60cd9b2, 0xb10be924,
    0x2f6f7c87, 0x58684c11, 0xc1611dab, 0xb6662d3d, 0x76dc4190, 0x01db7106,
    0x98d220bc, 0xefd5102a, 0x71b18589, 0x06b6b51f, 0x9fbfe4a5, 0xe8b8d433,
    0x7807c9a2, 0x0f00f934, 0x9609a88e, 0xe10e9818, 0x7f6a0dbb, 0x086d3d2d,
    0x91646c97, 0xe6635c01, 0x6b6b51f4, 0x1c6c6162, 0x856530d8, 0xf262004e,
    0x6c0695ed, 0x1b01a57b, 0x8208f4c1, 0xf50fc457, 0x65b0d9c6, 0x12b7e950,
    0x8bbeb8ea, 0xfcb9887c, 0x62dd1ddf, 0x15da2d49, 0x8cd37cf3, 0xfbd44c65,
    0x4db26158, 0x3ab551ce, 0xa3bc0074, 0xd4bb30e2, 0x4adfa541, 0x3dd895d7,
    0xa4d1c46d, 0xd3d6f4fb, 0x4369e96a, 0x346ed9fc, 0xad678846, 0xda60b8d0,
    0x44042d73, 0x33031de5, 0xaa0a4c5f, 0xdd0d7cc9, 0x5005713c, 0x270241aa,
    0xbe0b1010, 0xc90c2086, 0x5768b525, 0x206f85b3, 0xb966d409, 0xce61e49f,
    0x5edef90e, 0x29d9c998, 0xb0d09822, 0xc7d7a8b4, 0x59b33d17, 0x2eb40d81,
    0xb7bd5c3b, 0xc0ba6cad, 0xedb88320, 0x9abfb3b6, 0x03b6e20c, 0x74b1d29a,
    0xead54739, 0x9dd277af, 0x04db2615, 0x73dc1683, 0xe3630b12, 0x94643b84,
    0x0d6d6a3e, 0x7a6a5aa8, 0xe40ecf0b, 0x9309ff9d, 0x0a00ae27, 0x7d079eb1,
    0xf00f9344, 0x8708a3d2, 0x1e01f268, 0x6906c2fe, 0xf762575d, 0x806567cb,
    0x196c3671, 0x6e6b06e7, 0xfed41b76, 0x89d32be0, 0x10da7a5a, 0x67dd4acc,
    0xf9b9df6f, 0x8ebeeff9, 0x17b7be43, 0x60b08ed5, 0xd6d6a3e8, 0xa1d1937e,
    0x38d8c2c4, 0x4fdff252, 0xd1bb67f1, 0xa6bc5767, 0x3fb506dd, 0x48b2364b,
    0xd80d2bda, 0xaf0a1b4c, 0x36034af6, 0x41047a60, 0xdf60efc3, 0xa867df55,
    0x316e8eef, 0x4669be79, 0xcb61b38c, 0xbc66831a, 0x256fd2a0, 0x5268e236,
    0xcc0c7795, 0xbb0b4703, 0x220216b9, 0x5505262f, 0xc5ba3bbe, 0xb2bd0b28,
    0x2bb45a92, 0x5cb36a04, 0xc2d7ffa7, 0xb5d0cf31, 0x2cd99e8b, 0x5bdeae1d,
    0x9b64c2b0, 0xec63f226, 0x756aa39c, 0x026d930a, 0x9c0906a9, 0xeb0e363f,
    0x72076785, 0x05005713, 0x95bf4a82, 0xe2b87a14, 0x7bb12bae, 0x0cb61b38,
    0x92d28e9b, 0xe5d5be0d, 0x7cdcefb7, 0x0bdbdf21, 0x86d3d2d4, 0xf1d4e242,
    0x68ddb3f8, 0x1fda836e, 0x81be16cd, 0xf6b9265b, 0x6fb077e1, 0x18b74777,
    0x88085ae6, 0xff0f6a70, 0x66063bca, 0x11010b5c, 0x8f659eff, 0xf862ae69,
    0x616bffd3, 0x166ccf45, 0xa00ae278, 0xd70dd2ee, 0x4e048354, 0x3903b3c2,
    0xa7672661, 0xd06016f7, 0x4969474d, 0x3e6e77db, 0xaed16a4a, 0xd9d65adc,
    0x40df0b66, 0x37d83bf0, 0xa9bcae53, 0xdebb9ec5, 0x47b2cf7f, 0x30b5ffe9,
    0xbdbdf21c, 0xcabac28a, 0x53b39330, 0x24b4a3a6, 0xbad03605, 0xcdd70693,
    0x54de5729, 0x23d967bf, 0xb3667a2e, 0xc4614ab8, 0x5d681b02, 0x2a6f2b94,
    0xb40bbe37, 0xc30c8ea1, 0x5a05df1b, 0x2d02ef8d
]);


let ds = new Uint8Array(ab);

let crc = 0 ^ (-1);
console.log('crc len',ab.byteLength,crc)
//var dsArr = ds.readUint8Array();
for(var i = 0; i < ab.byteLength; i++){
  
  crc = (crc >>> 8) ^ table[(crc ^ ds[i]) & 0xFF];
  if(i==23851){
    console.log('crc ',i,crc)
  }
}

return (crc ^ (-1)) >>> 0;

}

const serviceUUID = ref('0000fee0-0000-1000-8000-00805f9b34fb') // 默认心率服务
const characteristicUUID = ref('0000fee1-0000-1000-8000-00805f9b34fb') // 默认心率测量特征
const deviceInfo = reactive({
  name: '',
  id: ''
})

// 十六进制字符串转ArrayBuffer
const hexStringToArrayBuffer = (hex) => {
  hex = hex.replace(/\s/g, '')
  if (hex.length % 2 !== 0) throw new Error('无效的十六进制字符串')
  
  const buffer = new Uint8Array(hex.length / 2)
  for (let i = 0; i < hex.length; i += 2) {
    buffer[i/2] = parseInt(hex.substr(i, 2), 16)
  }
  return buffer
}

// 发送命令
const sendCommand = async (hexCmd) => {
  try {
    // 将命令转换为ArrayBuffer
    const data = hexStringToArrayBuffer(hexCmd)    
    //await characteristic.writeValueWithoutResponse(data)
    await characteristic.writeValue(data)
    //addLog(`命令已发送: ${hexCmd}`)
    
  } catch (error) {
    addLog(`发送失败: ${error}`)
  }
}

// 日志记录
const addLog = (message) => {
  logs.unshift({
    timestamp: new Date().toLocaleTimeString(),
    message
  })
}

const ab2hex = (arrayBuffer) => {
  
	return Array.prototype.map.call(new Uint8Array(arrayBuffer), x => ('00' + x.toString(16)).slice(-2)).join('');

}

const checkCRC = async ()=>{
  await sendCommand('8512000000000000000000000000000000000000')
    const val = await characteristic.readValue()
    const hexVal = ab2hex(val.buffer)
    const res = val.getUint32(0,true);
    console.log('checkCRC',hexVal,val,res)
}

// 连接设备
const connectDevice = async () => {
  try {
    device.value = await navigator.bluetooth.requestDevice({
      acceptAllDevices: true,
      optionalServices: [serviceUUID.value],
      // filters: [ 
      //   { namePrefix: 'OTA' } 
      // ]
    })
    
    deviceInfo.name = device.value.name
    deviceInfo.id = device.value.id
    
    device.value.addEventListener('gattserverdisconnected', disconnectHandler)
    
    server = await device.value.gatt.connect()
    connected.value = true
    addLog(`已连接至设备: ${device.value.name}`)

    service = await server.getPrimaryService(serviceUUID.value)
    characteristic = await service.getCharacteristic(characteristicUUID.value)
    await sendCommand('8412000000000000000000000000000000000000')
    const val = await characteristic.readValue()
    const hexVal = ab2hex(val.buffer)
    imgType = val.getUint8(0,true);
    offset =  val.getUint32(1,true);
    blockSize =  val.getUint16(5,true);
    chip =  val.getUint16(7,true);

    console.log('hex',hexVal,val)
    addLog(`readVal: img:${imgType} offset:${offset} blockSize:${blockSize} chip:${chip}`)

  } catch (error) {
    addLog(`连接失败: ${error}`)
  }
}

// 断开连接处理
const disconnectHandler = () => {
  connected.value = false
  deviceInfo.name = ''
  deviceInfo.id = ''
  addLog('设备已断开连接')
}

// 主动断开连接
const disconnectDevice = () => {
  if (device.value?.gatt.connected) {
    device.value.gatt.disconnect()
  }
  connected.value = false
}


  const fileInfo = ref(null)
  const arrayBufferData = ref(null)
  
  const handleFileChange = (uploadFile) => {
    const file = uploadFile.raw
    if (!file) return
  
    // 存储文件信息
    fileInfo.value = {
      name: file.name,
      type: file.type,
      size: file.size
    }
  
    // 创建 FileReader
    const reader = new FileReader()
    
    reader.onload = (e) => {
      arrayBufferData.value = e.target.result
      ElMessage.success('文件读取成功')
      // 这里可以处理 ArrayBuffer 数据
      handleArrayBuffer(arrayBufferData.value)
    }
  
    reader.onerror = (error) => {
      ElMessage.error(`文件读取失败: ${error}`)
    }
  
    // 读取为 ArrayBuffer
    reader.readAsArrayBuffer(file)
  }

  const sendFinishCmd = async ()=>{
    await sendCommand('8312000000000000000000000000000000000000')
  }

  const sendEraseCmd = async ()=>{
    let buffer = new ArrayBuffer(20)
    let dataView = new DataView(buffer)
    dataView.setUint8(0, 0x81)
    dataView.setUint8(1, 0x00)
    console.log('blockSixe',blockSize)
    //计算需要擦除块的个数（文件大小+（块大小-1））/大小
    let block = Math.ceil((sendArrayBuffer.byteLength -(4096) + (blockSize - 1)) / blockSize)
    console.log('erase block',block)
    //block = block.toString(16)
    dataView.setUint8(2, 0x00)
    dataView.setUint8(3, 0x04)
    dataView.setUint8(4, block & 0xFF)
    dataView.setUint8(5, (block >> 8) &0xFF)
    for (let i = 6; i < 20; i++) {
      dataView.setUint8(i, 0x00)
    }
    let cmd = ab2hex(dataView.buffer)
    console.log('sendhex',block,cmd)
    await sendCommand(cmd)
    await new Promise(resolve => setTimeout(resolve, 3000));
    const val = await characteristic.readValue()
     const hexVal = ab2hex(val.buffer)
     console.log('erase',hexVal)
    // setTimeout(async ()=>{
    //   const val = await characteristic.readValue()
    //   const hexVal = ab2hex(val.buffer)
    //   console.log('erase',hexVal)
    // },2000)
  }

  const sendData = async (verify)=>{
    addLog('开始下载')
    let dataLength = 240
    let unsentLength = 0;
    let sentDataLen = 0
    let buffer = new ArrayBuffer(dataLength + 4)
    let dataView = new DataView(buffer)
    let arrayBuf = new Uint8Array(sendArrayBuffer)
    while(sentDataLen < sendArrayBuffer.byteLength){
      unsentLength = sendArrayBuffer.slice(sentDataLen).byteLength
      if (unsentLength < 240) {
        dataLength = unsentLength
      }      
      dataView.setUint8(0, verify?0x82:0x80)
      dataView.setUint8(1, dataLength)
      let startAddr = 0x4000, base = 16  
      let sendAddr = (startAddr + sentDataLen) / base   
      //sendAddr = ((startAddr + sentDataLen) / base).toString(16).padStart(4, '0')
      dataView.setUint8(2, sendAddr & 0xFF)
      dataView.setUint8(3, (sendAddr >>8) & 0xFF)
      for (let i = 4, j = 0; i < dataLength + 4; i++, j++) {
        dataView.setUint8(
          i, arrayBuf[sentDataLen + j]
        )
      }
    
      let cmd = ab2hex(dataView.buffer)     
      sentDataLen+=dataLength
      await sendCommand(cmd)
      //await characteristic.readValue()
      //const hexVal = ab2hex(val.buffer)
      //console.log('send:',verify,sentDataLen,sendArrayBuffer.byteLength,hexVal)
      progress.value = Math.ceil((sentDataLen/sendArrayBuffer.byteLength)*100)
    }
    addLog('下载完毕')
  }
      
  const handleArrayBuffer = (buffer) => {
    // 在这里处理你的 ArrayBuffer 数据
    console.log('Received ArrayBuffer:', buffer)
    // 示例：创建 DataView
    //const view = new DataView(buffer)
    sendArrayBuffer = buffer.slice(0x4000)
    crc.value = crc32(sendArrayBuffer)
    console.log('file',crc,sendArrayBuffer)
    
    //sendEraseCmd()    
    // 可以继续处理二进制数据...
  }
  </script>
  
  <style scoped>
  .file-reader {
    max-width: 500px;
    margin: 2rem auto;
    padding: 20px;
  }
  
  .file-info {
    margin-top: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 4px;
    text-align: left;
  }
  
  .file-info p {
    margin: 8px 0;
  }
  </style>